(function ($) {

    $(window).scroll(startCounter);
    function startCounter() {
        if ($(window).scrollTop() > ($('.section_home_4').offset().top - 500)) {
            $(window).off("scroll", startCounter);
            $('.counter').each(function () {
                var $this = $(this),
                    countTo = $this.attr('data-count');

                $({countNum: $this.text()}).animate({
                        countNum: countTo
                    },
                    {
                        duration: 2000,
                        easing: 'linear',
                        step: function () {
                            $this.text(Math.floor(this.countNum));
                        },
                        complete: function () {
                            $this.text(this.countNum);
                            //alert('finished');
                        }
                    });
            });
        }
    }


    var owl = $('.slick_slider');
    owl.owlCarousel({
        loop: true,
        margin: 0,
        autoplay: true,
        autoplayTimeout: 8000,
        nav: true,
        dots: false,
        autoHeight: true,
        items: 1,
        navText: ['<i class="left"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image"x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="18.4,39.8 3.4,21.4 18.4,2.7 "/> </svg> </i>', '<i class="right"><svg version="1.1" id="IdeaHall_x5F_Website_x5F_DesignTemplate_x5F_121416_xA0_Image2" x="0px" y="0px" viewBox="0 0 20 42.8"style="enable-background:new 0 0 20 42.8;" xml:space="preserve"> <style type="text/css">.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}</style> <polyline class="st0" points="2.4,2.7 17.4,21.2 2.4,39.8 "/> </svg> </i>']
    });


    $(window).resize(function () {
        //do something


        if (($(window).width() < 992)) {

        } else {
            owl.on('changed.owl.carousel', function (event) {
                var item = event.item.index - 2;

                $('.owl-item').not('.cloned').eq(item).find('.title h2')
                    .addClass('animated2')
                    .delay(700)
                    .animate({
                        padding: '25px 38px',
                    }, 1000);
                $('.owl-item').not('.cloned').eq(item).find('.text')
                    .delay(900)
                    .animate({
                        opacity: 1,
                    }, 1000);
            });
            $('.id_slide-1').find('.title h2')
                .addClass('animated2')
                .delay(700)
                .animate({
                    padding: '25px 38px',
                }, 1000);
            $('.id_slide-1').find('.text')
                .delay(900)
                .animate({
                    opacity: 1,
                }, 1000);
        }
    });
    if (($(window).width() < 992)) {
        // do something else
    } else {
        owl.on('changed.owl.carousel', function (event) {
            var item = event.item.index - 2;

            $('.owl-item').not('.cloned').eq(item).find('.title h2')
                .addClass('animated2')
                .delay(700)
                .animate({
                    padding: '25px 38px',
                }, 1000);
            $('.owl-item').not('.cloned').eq(item).find('.text')
                .delay(900)
                .animate({
                    opacity: 1,
                }, 1000);
        });
        $('.id_slide-1').find('.title h2')
            .addClass('animated2')
            .delay(700)
            .animate({
                padding: '25px 38px',
            }, 1000);
        $('.id_slide-1').find('.text')
            .delay(900)
            .animate({
                opacity: 1,
            }, 1000);
    }


})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./src/js/home_page.js
// module id = 12
// module chunks = 0